<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Products",
    }
</script>

<style scoped>

</style>